module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/blog your pathPrefix should be "blog"
  siteTitle: 'My Blog', // Navigation and Site Title
  siteTitleAlt: 'The blog of an egghead creator', // Alternative Site title for SEO
  siteTitleShort: 'Starter Blog', // short_name for manifest
  siteUrl: 'https://your-site.io', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: 'images/logo.png', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription: 'This is where they post things!',
  author: 'Author', // Author for schemaORGJSONLD
  organization: 'egghead.io LLC',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@eggheadio', // Twitter Username
  ogSiteName: 'egghead.io Gatsby Starter Blog', // Facebook Site Name
  ogLanguage: 'en_US',
  googleAnalyticsID: '',

  // Manifest and Progress color
  themeColor: '#5348FF',
  backgroundColor: '#2b2e3c',

  // Social component
  twitter: 'https://twitter.com/eggheadio/',
  twitterHandle: '@eggheadio',
  github: 'https://github.com/eggheadio/',
  linkedin: '',
}
